import type { rsvpSchemas, ZInfer } from 'types';
import { Api } from '../fetch';

const publicRsvp = {
  get: (id: string) => Api.get<'rsvp', 'getEvent'>('/rsvp/event/:id', { params: { id } }),
  rsvp: (id: string, data: ZInfer<typeof rsvpSchemas.rsvp>) =>
    Api.post<'rsvp', 'rsvp'>('/rsvp/to/:id', { params: { id }, body: data }),
} as const;

const userRsvp = {
  update: (id: string, data: ZInfer<typeof rsvpSchemas.updateRsvp>) =>
    Api.patch<'rsvp', 'updateRsvp'>('/rsvp/:id', { params: { id }, body: data }),
} as const;

const staffRsvp = {
  get: () => Api.get<'rsvp', 'getEvents'>('/rsvp/events'),
  upsert: (data: ZInfer<typeof rsvpSchemas.event>) => Api.post<'rsvp', 'upsertEvent'>('/rsvp/event', { body: data }),
  csv: (id: string) => Api.get<'rsvp', 'getEventRsvpCsv'>('/rsvp/event/csv/:id', { params: { id } }),
} as const;

export class RsvpNet {
  static public = publicRsvp;
  static user = userRsvp;
  static staff = staffRsvp;
}
